import { render, staticRenderFns } from "./ArtisanCheckbox.vue?vue&type=template&id=b2d1de12"
import script from "./ArtisanCheckbox.vue?vue&type=script&lang=js"
export * from "./ArtisanCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports